var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NbButton',{attrs:{"title":_vm.$t('overpacksListPage.readyToDispatch'),"variant":"tertiary","disabled":_vm.loading},on:{"click":function($event){return _vm.dispatchOverpack()}}},[_vm._v(" "+_vm._s(_vm.loading ? _vm.$t("loading") + "..." : _vm.$t("overpacksListPage.readyToDispatch"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }